import { render, staticRenderFns } from "./TrackDetailsPanel.vue?vue&type=template&id=f5a76ace&scoped=true"
import script from "./TrackDetailsPanel.vue?vue&type=script&lang=ts"
export * from "./TrackDetailsPanel.vue?vue&type=script&lang=ts"
import style0 from "./TrackDetailsPanel.vue?vue&type=style&index=0&id=f5a76ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a76ace",
  null
  
)

export default component.exports